export const nav_items = [
  {
    id: 1,
    title: 'Use cases',
    anchor: 'use-cases',
  },
  {
    id: 2,
    title: 'Benefits',
    anchor: 'benefits',
  },
  {
    id: 3,
    title: 'How to use',
    anchor: 'try-it-out',
  },
  // {
  //   id: 4,
  //   title: 'Try it out',
  //   anchor: 'try-it-out',
  // },
  {
    id: 5,
    title: 'Book a demo',
    anchor: 'contact-us',
  },
];
